// extracted by mini-css-extract-plugin
export var calendarView = "_id-0";